export const ADVANCE_STATUS_LABELS: Record<
  string,
  { label: string; tone: 'success' | 'warning' | 'danger' | 'info' | 'neutral' }
> = {
  active: { label: 'Активен', tone: 'info' },
  partially_settled: { label: 'Частично закрыт', tone: 'warning' },
  settled: { label: 'Отработан / Закрыт', tone: 'success' },
  overdue: { label: 'Просрочен', tone: 'danger' },
  claim_sent: { label: 'Направлена претензия', tone: 'danger' },
};

export const TAX_STATUS_LABELS: Record<
  string,
  { label: string; tone: 'success' | 'warning' | 'danger' | 'info' | 'neutral' }
> = {
  planned: { label: 'Запланировано', tone: 'info' },
  reserved: { label: 'Зарезервировано', tone: 'warning' },
  paid: { label: 'Уплачено', tone: 'success' },
  overdue: { label: 'Просрочено', tone: 'danger' },
};
